import clsx from 'clsx';

interface Props {
  message: string | undefined;
  wrapText?: boolean;
}

function ErrorMessage({ message, wrapText = false }: Props) {
  return (
    <div
      className={clsx(
        'absolute left-0',
        wrapText ? '-bottom-3 h-6 md:-bottom-4 md:h-8' : 'bottom-0',
      )}
    >
      <p
        className={clsx(
          'text-input-error-mobile md:text-input-error text-orange-400',
          !wrapText && 'whitespace-nowrap',
        )}
      >
        {message}
      </p>
    </div>
  );
}

export default ErrorMessage;
